import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { Router, RouterLink } from '@angular/router';
import { DatadogService } from 'src/app/services/data-dog.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-page-not-found',
  styleUrls: ['./page-not-found.component.scss'],
  templateUrl: './page-not-found.component.html',
  imports: [RouterLink, MatButton],
})
export class PageNotFoundComponent implements OnInit {
  private dataDogService = inject(DatadogService);
  private router = inject(Router);

  ngOnInit(): void {
    this.dataDogService.errorMessage('Unkown route', { route: this.router.url });
  }
}
